import { ArticleStatus } from "../../types/entities";
import { isLocal } from "../config";
import { GTM_EVENTS, dataLayerPush } from "../event";
import { generateUniqueId } from "../utils";

export const isSupportApp =
  !window.location.host.includes("aptedge.io") &&
  !window.location.host.includes("localhost:3000");

export const urlProtocol = isLocal() ? "http" : "https";

export const triggerViewSearchInWebAppEvent = (
  ticketSubject: string,
  ticketId: string
): void => {
  dataLayerPush({
    event: GTM_EVENTS.GTM_SUPPORT_CLICK_VIEW_SEARCH_IN_WEB_APP,
    data: {
      ticket_title: ticketSubject,
      ticket_id: ticketId
    }
  });
};

export const openInWebApp = (
  aptEdgeBaseUrl: string,
  queryString: string,
  ticketSubject: string,
  ticketId: string
): void => {
  let url = `${urlProtocol}://${aptEdgeBaseUrl}/search`;
  if (queryString) {
    url += `?${queryString}&answerId=${generateUniqueId()}`;
  }
  triggerViewSearchInWebAppEvent(ticketSubject, ticketId);
  window.open(url, "_blank");
};

export const openGeneratedKnowledgeArticleInWebApp = (
  aptEdgeBaseUrl: string,
  articleId: string
): void => {
  const url = `${urlProtocol}://${aptEdgeBaseUrl}/articles?articleId=${articleId}`;
  window.open(url, "_blank");
};

export const openGeneratedKnowledgeReviewInWebApp = (
  aptEdgeBaseUrl: string,
  ticketId: number,
  articleCreationState: string,
  articleStatus: ArticleStatus
): void => {
  const url = `${urlProtocol}://${aptEdgeBaseUrl}/articles/review?ticketId=${ticketId}&articleCreationState=${articleCreationState}&articleStatus=${articleStatus}`;
  window.open(url, "_blank");
};

export const openGeneratedKnowledgeDrawerInWebApp = (
  aptEdgeBaseUrl: string,
  answerId: string,
  questionIndex: number,
  searchQuery?: string
): void => {
  const base = `${urlProtocol}://${aptEdgeBaseUrl}/search`;
  const params = new URLSearchParams();
  if (searchQuery) params.set("query", searchQuery);
  params.set("answerId", answerId);
  params.set("questionIndex", String(questionIndex));
  params.set("openArticleDrawer", "true");
  window.open(`${base}?${params.toString()}`, "_blank");
};
